import { FC } from 'react'
import { Input } from 'entities/Input'
import { TwoColumnedDiv } from 'entities/TwoColumnedDiv'
import { usePaymentConfigStore } from 'shared/store/paymentSlice'

export const Datatrans: FC = () => {
  const dataTrans = usePaymentConfigStore().paymentConfig.dataTrans
  const isConfigDataLoading = usePaymentConfigStore().isConfigDataLoading
  const updateDataTransConfig = usePaymentConfigStore().updateDataTransConfig

  const handleUpdate = (paramName: string, value: string) => {
    updateDataTransConfig({ [paramName]: value })
  }

  return (
    <TwoColumnedDiv key={`dataTrans_input_${isConfigDataLoading}`}>
      {fieldsDatatrans.map(field => (
        <Input
          key={`dataTrans_input-${field.value}-${dataTrans?.[field.value as 'merchantId']}`}
          label={field.label}
          type={field.type}
          autoComplete={field.type && 'new-password'}
          defaultValue={dataTrans?.[field.value as 'merchantId']}
          onBlur={e => handleUpdate(field.value, e)}
        />
      ))}
    </TwoColumnedDiv>
  )
}

const fieldsDatatrans = [
  {
    value: 'merchantId',
    label: 'MerchantID'
  },
  {
    value: 'password',
    label: 'Password',
    type: 'password'
  }
]
